import React, { useEffect } from "react";
import "./agroquimicosabejas.css";

const AgroquimicosAbejas = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="container agroquimicosabejas-container">
      <div className='row'>
            <div className='col_12'>
                <div className='agroquimicosabejas_title'>
                    <h1>Argoquímicos Toxícos para las Abejas</h1>
                </div>
            </div>
        </div>
      
      <hr className="hr-gob" />
      <div>
      <div>
        <iframe src="https://files.catbox.moe/l5fl08.pdf" height="800" width="1110">
          Agroquimicos
        </iframe>
      </div>
      </div>
    </div>
    
  );
};

export default AgroquimicosAbejas;
